/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_BInputs */

const en_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program B`)
};

const fr_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme B`)
};

const de_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm B`)
};

const it_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma B`)
};

const ru_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа B`)
};

const es_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa B`)
};

const zh_cn2_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B计划`)
};

const ja_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムB`)
};

const hi_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम बी`)
};

const pt_pt2_subtitle_export_program_b = /** @type {(inputs: Subtitle_Export_Program_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa B`)
};

/**
* | output |
* | --- |
* | "Program B" |
*
* @param {Subtitle_Export_Program_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_b = /** @type {((inputs?: Subtitle_Export_Program_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_b(inputs)
	if (locale === "de") return de_subtitle_export_program_b(inputs)
	if (locale === "it") return it_subtitle_export_program_b(inputs)
	if (locale === "ru") return ru_subtitle_export_program_b(inputs)
	if (locale === "es") return es_subtitle_export_program_b(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_b(inputs)
	if (locale === "ja") return ja_subtitle_export_program_b(inputs)
	if (locale === "hi") return hi_subtitle_export_program_b(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_b(inputs)
	return en_subtitle_export_program_b(inputs)
});